import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Snackbar, Alert } from "@mui/material";
import * as actionTypes from "../../store/types";

const SnackbarAlert = () => {
  const open = useSelector((state) => state.snackbarAlertOpen);
  const dispatch = useDispatch();
  const [transition, setTransition] = useState(undefined);
  const handleClose = () => {
    dispatch({ type: actionTypes.SET_SNACKBAR_ALERT, payload: false });
  };

  return (
    <div>
      <Snackbar
        autoHideDuration={3000}
        severity='success'
        open={open}
        onClose={handleClose}
        TransitionComponent={transition}
        key={transition ? transition.name : ""}
      >
        <Alert sx={{ backgroundColor: "#005850", color: "white", "& .MuiAlert-icon": { color: "white" } }}>
          Added to order
        </Alert>
      </Snackbar>
    </div>
  );
};

export default SnackbarAlert;
